export const steamEndpointIds = {
    SAVE_STEAM_USER_INFO: 'SAVE_STEAM_USER_INFO',
    INIT_STEAM_REVIEWS_REPORT: 'INIT_STEAM_REVIEWS_REPORT',
};
